import React, { useState } from "react";
import Slider from "./Slider"; // Assuming Slider is your component
import "animate.css";
import NB from "./NB";

const SimulateurCreditImmo = ({ titre }) => {
  const [loanAmount, setLoanAmount] = useState(50000000); // Montant du crédit
  const [annualInterestRate, setAnnualInterestRate] = useState(7); // Taux d'intérêt annuel
  const [loanTermMonths, setLoanTermMonths] = useState(12); // Durée du prêt en mois
  const [monthlyPayment, setMonthlyPayment] = useState(null); // Paiement mensuel calculé

  const calculateMonthlyPayment = () => {
    const P = loanAmount;
    const r = annualInterestRate / 100 / 12; // Convert annual rate to monthly and into decimal
    const n = loanTermMonths; // Duration is already in months

    // Check if any of the inputs are zero or null which would make the calculation invalid
    if (!P || !r || !n) {
      setMonthlyPayment("Invalid input");
      return <div>Invalid Input</div>;
    }

    const M = (P * (r * Math.pow(1 + r, n))) / (Math.pow(1 + r, n) - 1);

    setMonthlyPayment(isFinite(M) ? M : "Invalid input"); // Set the calculated monthly payment
  };

  const isButtonDisabled =
    !loanAmount || !annualInterestRate || !loanTermMonths;

  return (
    <div className="simulator-container">
      <div className="simulateur-titre">{titre}</div>
      <div className="simulator">
        <div className="simulator-right">
          <Slider
            label="Montant du crédit:"
            unit="XOF"
            min={0}
            max={200000000}
            stepCount={2} // Adjust for smoother sliding
            value={loanAmount}
            setValue={setLoanAmount}
          />

          <Slider
            label="Taux:"
            unit="%"
            min={7}
            max={15}
            stepCount={5} // Adjust for smoother sliding
            value={annualInterestRate}
            setValue={setAnnualInterestRate}
          />
          <Slider
            label="Durée:"
            unit="mois"
            min={0}
            max={240}
            stepCount={4} // Adjust for smoother sliding
            value={loanTermMonths}
            setValue={setLoanTermMonths}
          />

          <div className="btn-container">
            <button
              onClick={calculateMonthlyPayment}
              className="btn-full"
              disabled={isButtonDisabled}
            >
              Lancer la simulation
            </button>
          </div>

          <NB />
        </div>
        {monthlyPayment !== null && (
          <div className="simulator-left animate__animated animate__zoomInUp">
            <div className="result-row">
              <h3>Montant du crédit:</h3>
              <div className="result-row-variable">
                {loanAmount.toLocaleString("fr-FR")} XOF
              </div>
            </div>
            <div className="result-row">
              <h3>Taux:</h3>
              <div className="result-row-variable">
                {annualInterestRate.toFixed(0)}%
              </div>
            </div>
            <div className="result-row">
              <h3>Durée</h3>
              <div className="result-row-variable">
                {loanTermMonths.toFixed(0)} mois{" "}
              </div>
            </div>

            <div className="result-row">
              <h3>Paiement Mensuel:</h3>
              <div className="result-row-variable final-result">
                {Math.floor(monthlyPayment).toLocaleString("fr-FR")} XOF{" "}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SimulateurCreditImmo;
